import { isRouteErrorResponse, Link, useRouteError } from 'react-router'

export function RootErrorBoundary() {
  const error = useRouteError()
  const is404 = isRouteErrorResponse(error) && error.status === 404
  return (
    <main className="container container--narrow" style={{ paddingBlock: '4rem' }}>
      <h1>{is404 ? 'Page not found' : 'Something went wrong'}</h1>
      <p className="muted">
        {is404
          ? "We couldn't find that page."
          : error instanceof Error
            ? error.message
            : 'An unexpected error occurred.'}
      </p>
      <div className="cluster">
        <Link className="btn" to="/">
          Go home
        </Link>
        <button
          type="button"
          className="btn btn--secondary"
          onClick={() => window.location.reload()}
        >
          Reload
        </button>
      </div>
    </main>
  )
}
